/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAction, createSlice, createSelector } from '@reduxjs/toolkit';

import createRequestActionTypes from 'store/helpers/createRequestActionTypes';
import {
  handleClearErrors,
  onFailure,
  onSuccessDetail,
  onSuccessList,
} from 'store/helpers/commonHandlers';
import getSplicedList from 'lib/utils/getUpdatedList';

const name = 'forms';

/** ActionType for Request */
export const [
  GET_SUMMARIZE_FORMSET_LIST,
  GET_SUMMARIZE_FORMSET_LIST_SUCCESS,
  GET_SUMMARIZE_FORMSET_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_SUMMARIZE_FORMSET_LIST');
export const [
  GET_FORMSET_DETAIL,
  GET_FORMSET_DETAIL_SUCCESS,
  GET_FORMSET_DETAIL_FAILURE,
] = createRequestActionTypes(name, 'GET_FORMSET_DETAIL');
export const [
  GET_ASSIGN_FORMSET_LIST,
  GET_ASSIGN_FORMSET_LIST_SUCCESS,
  GET_ASSIGN_FORMSET_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_ASSIGN_FORMSET_LIST');
export const [
  GET_ASSIGN_FORMSET_DETAIL,
  GET_ASSIGN_FORMSET_DETAIL_SUCCESS,
  GET_ASSIGN_FORMSET_DETAIL_FAILURE,
] = createRequestActionTypes(name, 'GET_ASSIGN_FORMSET_DETAIL');
export const [
  GET_FORMSET_COLLECTION_LIST,
  GET_FORMSET_COLLECTION_LIST_SUCCESS,
  GET_FORMSET_COLLECTION_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_FORMSET_COLLECTION_LIST');
export const [
  ASSIGN_FORMSET,
  ASSIGN_FORMSET_SUCCESS,
  ASSIGN_FORMSET_FAILURE,
] = createRequestActionTypes(name, 'ASSIGN_FORMSET');
export const [
  NOTIFY_ASSIGN,
  NOTIFY_ASSIGN_SUCCESS,
  NOTIFY_ASSIGN_FAILURE,
] = createRequestActionTypes(name, 'NOTIFY_ASSIGN');
export const [
  CREATE_SUBMITTED_FORMSET,
  CREATE_SUBMITTED_FORMSET_SUCCESS,
  CREATE_SUBMITTED_FORMSET_FAILURE,
] = createRequestActionTypes(name, 'CREATE_SUBMITTED_FORMSET');
export const [
  CREATE_FORMSET,
  CREATE_FORMSET_SUCCESS,
  CREATE_FORMSET_FAILURE,
] = createRequestActionTypes(name, 'CREATE_FORMSET');
export const [
  UPDATE_FORMSET,
  UPDATE_FORMSET_SUCCESS,
  UPDATE_FORMSET_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_FORMSET');
export const [
  DELETE_FORMSET,
  DELETE_FORMSET_SUCCESS,
  DELETE_FORMSET_FAILURE,
] = createRequestActionTypes(name, 'DELETE_FORMSET');
export const [
  CREATE_FORMSET_COLLECTION,
  CREATE_FORMSET_COLLECTION_SUCCESS,
  CREATE_FORMSET_COLLECTION_FAILURE,
] = createRequestActionTypes(name, 'CREATE_FORMSET_COLLECTION');
export const [
  UPDATE_FORMSET_COLLECTION,
  UPDATE_FORMSET_COLLECTION_SUCCESS,
  UPDATE_FORMSET_COLLECTION_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_FORMSET_COLLECTION');
export const [
  DELETE_FORMSET_COLLECTION,
  DELETE_FORMSET_COLLECTION_SUCCESS,
  DELETE_FORMSET_COLLECTION_FAILURE,
] = createRequestActionTypes(name, 'DELETE_FORMSET_COLLECTION');
export const [
  CREATE_PROTOCOL,
  CREATE_PROTOCOL_SUCCESS,
  CREATE_PROTOCOL_FAILURE,
] = createRequestActionTypes(name, 'CREATE_PROTOCOL');
export const [
  GET_PROTOCOL_LIST,
  GET_PROTOCOL_LIST_SUCCESS,
  GET_PROTOCOL_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_PROTOCOL_LIST');
export const [
  GET_PROTOCOL_DETAIL,
  GET_PROTOCOL_DETAIL_SUCCESS,
  GET_PROTOCOL_DETAIL_FAILURE,
] = createRequestActionTypes(name, 'GET_PROTOCOL_DETAIL');
export const [
  DELETE_PROTOCOL,
  DELETE_PROTOCOL_SUCCESS,
  DELETE_PROTOCOL_FAILURE,
] = createRequestActionTypes(name, 'DELETE_PROTOCOL');
export const [
  ASSIGN_PROTOCOL,
  ASSIGN_PROTOCOL_SUCCESS,
  ASSIGN_PROTOCOL_FAILURE,
] = createRequestActionTypes(name, 'ASSIGN_PROTOCOL');
export const [
  UPDATE_ASSIGNED_PROTOCOL,
  UPDATE_ASSIGNED_PROTOCOL_SUCCESS,
  UPDATE_ASSIGNED_PROTOCOL_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_ASSIGNED_PROTOCOL');
export const [
  DELETE_ASSIGNED_PROTOCOL,
  DELETE_ASSIGNED_PROTOCOL_SUCCESS,
  DELETE_ASSIGNED_PROTOCOL_FAILURE,
] = createRequestActionTypes(name, 'DELETE_ASSIGNED_PROTOCOL');
export const [
  UPDATE_QUESTION,
  UPDATE_QUESTION_SUCCESS,
  UPDATE_QUESTION_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_QUESTION');
export const [
  UPDATE_STANDARD,
  UPDATE_STANDARD_SUCCESS,
  UPDATE_STANDARD_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_STANDARD');
export const [
  UPDATE_SUBMITTED_FORMSET,
  UPDATE_SUBMITTED_FORMSET_SUCCESS,
  UPDATE_SUBMITTED_FORMSET_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_SUBMITTED_FORMSET');

const slice = createSlice({
  name,
  initialState: {
    summarizeList: null,
    assignList: null,
    collectionList: null,
    protocolList: null,
    protocolDetails: {},
    formsetDetails: {},
    assignDetails: {},
    errors: {},
    count: {},
    next: {},
    pages: {},
  },
  reducers: {
    clearErrors: handleClearErrors,
  },
  extraReducers: {
    [GET_SUMMARIZE_FORMSET_LIST_SUCCESS]: onSuccessList('summarizeList'),
    [GET_FORMSET_DETAIL_SUCCESS]: onSuccessDetail('formsetDetails', 'id'),
    [GET_FORMSET_DETAIL_FAILURE]: onFailure('formsetDetails'),
    [GET_ASSIGN_FORMSET_LIST_SUCCESS]: (
      state,
      { payload: { results, next, count, page } },
    ) => {
      state.assignList = results;
      state.next.assignList = next;
      state.count.assignList = count;
      state.errors.assignList = null;
      state.pages.assignList = page;
    },
    [GET_ASSIGN_FORMSET_DETAIL_SUCCESS]: onSuccessDetail('assignDetails', 'id'),
    [GET_ASSIGN_FORMSET_DETAIL_FAILURE]: onFailure('assignDetails'),
    [GET_FORMSET_COLLECTION_LIST_SUCCESS]: onSuccessList('collectionList'),
    [CREATE_FORMSET_COLLECTION_SUCCESS]: (state, { payload }) => {
      if (state.collectionList) {
        state.collectionList = [...state.collectionList, payload];
      }
    },
    [CREATE_FORMSET_COLLECTION_FAILURE]: onFailure('createFormsetCollection'),
    [DELETE_FORMSET_COLLECTION_SUCCESS]: (state, { payload }) => {
      if (state.collectionList) {
        state.collectionList = getSplicedList(state.collectionList, payload, {
          exchange: false,
        });
      }
    },
    [DELETE_FORMSET_COLLECTION_FAILURE]: onFailure('deleteFormCollection'),
    [UPDATE_FORMSET_COLLECTION_SUCCESS]: (state, { payload }) => {
      if (state.collectionList) {
        state.collectionList = getSplicedList(state.collectionList, payload);
      }
    },
    [UPDATE_FORMSET_COLLECTION_FAILURE]: onFailure('updateFormsetCollection'),
    [ASSIGN_FORMSET_FAILURE]: onFailure('assignFormset'),
    [CREATE_FORMSET_FAILURE]: onFailure('createFormset'),
    [UPDATE_FORMSET_SUCCESS]: (state, { payload }) => {
      state.formsetDetails[payload.id] = payload;
    },
    [UPDATE_FORMSET_FAILURE]: onFailure('updateFormset'),
    [DELETE_FORMSET_SUCCESS]: (state, { payload }) => {
      if (state.summarizeList) {
        state.summarizeList = getSplicedList(state.summarizeList, payload, {
          exchange: false,
        });
      }
    },
    [NOTIFY_ASSIGN_FAILURE]: onFailure('notify'),
    [CREATE_SUBMITTED_FORMSET_FAILURE]: onFailure('createSubmitted'),
    [CREATE_PROTOCOL_SUCCESS]: (state, { payload }) => {
      if (state.protocolList) {
        state.protocolList = getSplicedList(state.protocolList, payload);
      }
    },
    [CREATE_PROTOCOL_FAILURE]: onFailure('createProtocol'),
    [GET_PROTOCOL_LIST_SUCCESS]: onSuccessList('protocolList'),
    [GET_PROTOCOL_DETAIL_SUCCESS]: onSuccessDetail('protocolDetails', 'id'),
    [DELETE_PROTOCOL_SUCCESS]: (state, { payload }) => {
      if (state.protocolList) {
        state.protocolList = getSplicedList(state.protocolList, payload, {
          exchange: false,
        });
      }
    },
    [DELETE_PROTOCOL_FAILURE]: onFailure('deleteProtocol'),
    [ASSIGN_FORMSET_FAILURE]: onFailure('assignProtocol'),
    [UPDATE_ASSIGNED_PROTOCOL_FAILURE]: onFailure('assignProtocol'),
    [UPDATE_QUESTION_SUCCESS]: (state, { payload }) => {
      const { id, formset_id: formsetId } = payload;
      if (state.formsetDetails?.[formsetId]) {
        const detail = { ...state.formsetDetails?.[formsetId] };
        const questions = detail.questions || [];
        if (questions.length) {
          const nextQuestions = [...questions];
          const findedIdx = nextQuestions.findIndex((o) => o.id === id);
          nextQuestions[findedIdx] = {
            ...nextQuestions[findedIdx],
            ...payload,
          };
          detail.questions = nextQuestions;
          state.formsetDetails[formsetId] = detail;
        }
      }
    },
    [UPDATE_QUESTION_FAILURE]: onFailure('updateQuestion'),
    [UPDATE_STANDARD_SUCCESS]: (state, { payload }) => {
      const { id, formset_id: formsetId } = payload;
      if (state.formsetDetails?.[formsetId]) {
        const detail = { ...state.formsetDetails?.[formsetId] };
        const standards = detail.standards || [];
        if (standards.length) {
          const nextStandards = [...standards];
          const findedIdx = nextStandards.findIndex((o) => o.id === id);
          nextStandards[findedIdx] = {
            ...nextStandards[findedIdx],
            ...payload,
          };
          detail.standards = nextStandards;
          state.formsetDetails[formsetId] = detail;
        }
      }
    },
    [UPDATE_STANDARD_FAILURE]: onFailure('updateStandard'),
    [UPDATE_SUBMITTED_FORMSET_SUCCESS]: (state, { payload }) => {
      const { id, assigned, ...rest } = payload;
      if (state.assignDetails?.[assigned]) {
        const assignedFormset = state.assignDetails?.[assigned];
        const submits = assignedFormset?.submits || [];
        const index = submits.findIndex((o) => o.id === id);
        const nextSubmits = [...submits];
        if (index !== -1) {
          nextSubmits[index] = { ...nextSubmits[index], ...rest };
        }
        state.assignDetails = {
          ...state.assignDetails,
          [assigned]: { ...assignedFormset, submits: nextSubmits },
        };
      }
    },
  },
});

/** Action for Request */
export const getSummarizeFormsetList = createAction(GET_SUMMARIZE_FORMSET_LIST);
export const getFormsetDetail = createAction(GET_FORMSET_DETAIL);
export const getAssignFormsetList = createAction(GET_ASSIGN_FORMSET_LIST);
export const getAssignFormsetDetail = createAction(GET_ASSIGN_FORMSET_DETAIL);
export const getFormsetCollectionList = createAction(
  GET_FORMSET_COLLECTION_LIST,
);
export const getProtocolList = createAction(GET_PROTOCOL_LIST);
export const getProtocolDetail = createAction(GET_PROTOCOL_DETAIL);
export const assignFormset = createAction(ASSIGN_FORMSET);
export const notifyAssign = createAction(NOTIFY_ASSIGN);
export const createSubmittedFormset = createAction(CREATE_SUBMITTED_FORMSET);
export const createFormset = createAction(CREATE_FORMSET);
export const updateFormset = createAction(UPDATE_FORMSET);
export const deleteFormset = createAction(DELETE_FORMSET);
export const createFormsetCollection = createAction(CREATE_FORMSET_COLLECTION);
export const updateFormsetCollection = createAction(UPDATE_FORMSET_COLLECTION);
export const deleteFormsetCollection = createAction(DELETE_FORMSET_COLLECTION);
export const createProtocol = createAction(CREATE_PROTOCOL);
export const deleteProtocol = createAction(DELETE_PROTOCOL);
export const assignProtocol = createAction(ASSIGN_PROTOCOL);
export const updateAssignedProtocol = createAction(UPDATE_ASSIGNED_PROTOCOL);
export const deleteAssignedProtocol = createAction(DELETE_ASSIGNED_PROTOCOL);
export const updateQuestion = createAction(UPDATE_QUESTION);
export const updateStandard = createAction(UPDATE_STANDARD);
export const updateSubmittedFormset = createAction(UPDATE_SUBMITTED_FORMSET);

/** General Action */
export const { clearErrors } = slice.actions;

/** Reducer */
export const forms = slice.reducer;

/** Selectors */
const errorSelector = createSelector(
  (state) => state.errors,
  (errors) => ({ errors }),
);
const summarizeSelector = createSelector(
  (state) => state.summarizeList,
  (state) => state.count.summarizeList,
  (summarizeList, summarizeCount) => ({
    summarizeFormsetList: summarizeList,
    summarizeCount,
  }),
);
const formsetDetailSelector = createSelector(
  (state) => state.formsetDetails,
  (formsetDetails) => ({ formsetDetails }),
);
const assignListSelector = createSelector(
  (state) => state.assignList,
  (state) => state.count.assignList,
  (state) => state.pages.assignList,
  (assignList, allCount, pageNum) => ({ assignList, allCount, pageNum }),
);
const assignDetailSelector = createSelector(
  (state) => state.assignDetails,
  (assignDetails) => ({ assignDetails }),
);
const collectionListSelector = createSelector(
  (state) => state.collectionList,
  (state) => state.count.collectionList,
  (collectionList, collectionCount) => ({ collectionList, collectionCount }),
);
const protocolListSelector = createSelector(
  (state) => state.protocolList,
  (state) => state.count.protocolList,
  (protocolList, protocolListCount) => ({ protocolList, protocolListCount }),
);
const protocolDetailSelector = createSelector(
  (state) => state.protocolDetails,
  (protocolDetails) => ({ protocolDetails }),
);

export const selectors = {
  errors: (state) => errorSelector(state[name]),
  summarizeList: (state) => summarizeSelector(state[name]),
  formsetDetail: (state) => formsetDetailSelector(state[name]),
  assignList: (state) => assignListSelector(state[name]),
  assignDetail: (state) => assignDetailSelector(state[name]),
  collectionList: (state) => collectionListSelector(state[name]),
  protocolList: (state) => protocolListSelector(state[name]),
  protocolDetail: (state) => protocolDetailSelector(state[name]),
};

export default slice;
